var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._b({attrs:{"src":"https://ukinvocap.blob.core.windows.net/marketing/logo.png"}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }